/* This file is auto-generated, do not touch! Please edit the SVG file instead. */
import React from "react";
import { css } from "glamor";

function Split({ width, height, style, color = "currentColor", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      {...props}
      {...css(style)}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 9L26 5"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M30 9L26 13"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M6 5L2 9"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M2 9L6 13"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M10 9H3"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M22 9H29"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16 15L22 9"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16 15L10 9"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16 28L16 15"
        stroke={color}
        className="path"
        strokeWidth="3.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Split;
